<template>
  <div id="app">
    <app-header appTitle="Common App Status" :branding-image="deptLogo">
      <tabs-nav slot="tabs-nav" :links="navLinks" />
      <mobile-nav slot="mobile-nav" :links="navLinks" />
    </app-header>
    <main class="container main">
      <router-view />
    </main>
    <app-footer :links="navLinks" />
  </div>
</template>

<script>
import logo from "@/assets/DPD BELL logo_w.png";

export default {
  data() {
    return {
      deptLogo: {
        src: logo,
        alt: "Philadelphia Department of Planning and Development logo",
        width: "190px"
      },
      navLinks: [
        {
          href: "Home",
          text: "Home"
        },
        {
          href: "Status",
          text: "Status"
        },
      ]
    };
},
}
</script>

<style lang="scss">
@import "./assets/scss/main.scss";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#trusted-site {
  display: none;
}
</style>

